module.exports = __webpack_public_path__ + "static/kerry_character_wishmastree_01-4613dddaf9f2de98a230c0574238e1d4.jpg";